// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__O9wv-","title":"Header_title__ilgop","side":"Header_side__3rkng"};